import { atom } from "recoil";

export const SettingState = atom({
  key: "SettingState",
  default: undefined,
});
